import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { projectFilesService } from '../api/project-files.service';
import { PROJECT_FILE_KEYS } from './queryKeys';

export function useProjectFileCounts(projectId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: PROJECT_FILE_KEYS.counts(orgId ?? '', projectId),
    queryFn: async ({ signal }) => {
      const response = await projectFilesService.getFileCounts(projectId, signal);
      return response.data;
    },
    staleTime: 30_000,
    enabled: !!orgId && !!projectId,
  });
}
